<template>
  <article
    class="box-border min-h-[29.7cm] w-[21cm] bg-white px-[3mm] py-[6mm] text-sm text-neutral-700 shadow-xl"
  >
    <slot />
  </article>
</template>
